import { useRegions } from '@/data/region';
import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';

const RegionFields = () => {
  const regions = useRegions();
  const form = useFormContext();

  if (regions.isLoading && !regions.data) {
    return null;
  }

  return (
    <div className="mb-8 space-y-1">
      <h3>Regions</h3>
      <span className="text-muted-foreground">Where do you plan to coach?</span>
      <div className="grid gap-2">
        <FormField
          control={form.control}
          name="regions"
          render={() => (
            <FormItem>
              {regions.data.map((region) => (
                <FormField
                  key={region.id}
                  control={form.control}
                  name="regions"
                  render={({ field }) => {
                    return (
                      <FormItem
                        key={region.id}
                        className="flex flex-row items-center space-x-3 space-y-0 mb-2"
                      >
                        <FormControl>
                          <Checkbox
                            checked={field.value?.includes(region.id)}
                            onCheckedChange={(checked) => {
                              return checked
                                ? field.onChange([...field.value, region.id])
                                : field.onChange(
                                    field.value?.filter(
                                      (value) => value !== region.id
                                    )
                                  );
                            }}
                          />
                        </FormControl>
                        <div className="leading-tight block">
                          <FormLabel className="">{region.name}</FormLabel>
                        </div>
                      </FormItem>
                    );
                  }}
                />
              ))}
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default RegionFields;
